import {useState} from 'react';
import {Stack, Box} from '@mui/material';
import Image from 'src/minimal-components/image';

import Header from './header';
import {environment} from '@shared/config/environment';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function MainLayout({children}: Props) {
  const [selectedHelpOption, setSelectedHelpOption] = useState('');
  const {
    IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED,
    LMS_DECRYPTKEY_EXTERNAL_SITE_AS_EMBEDDED
  } = environment || [];
  let value = false;
  if (IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED === true) {
    value = true;
  }
  const brandLogo = (
    <Box sx={{position: 'absolute', top: 20, left: 20}}>
      <Image src="/logos/images/Original.svg" alt="BytePad Logo" width={150} />
    </Box>
  );

  const companyLogo = (
    <Box sx={{position: 'absolute', right: 10, bottom: 10}}>
      <Image
        src="/logos/images/InterScripts v2.png"
        alt="InterScripts Logo"
        width={150}
      />
    </Box>
  );

  const handleHelpOptionClick = async (url: string) => {
    setSelectedHelpOption(url);
  };

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', height: 1}}>
      <Stack
        component="main"
        direction="row"
        sx={{
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          justifyContent: 'flex-end',
          background: `url('/logos/images/Lagangarbh-Hut-Dashboard.jpg') no-repeat center center fixed`,
          backgroundSize: 'cover'
        }}>
        {!value && brandLogo}

        <Header
          onHelpOptionClick={handleHelpOptionClick}
          selectedHelpOption={selectedHelpOption}
          setSelectedHelpOption={setSelectedHelpOption}
        />

        <Box
          sx={{
            width: '75%',
            minHeight: '100vh',
            backgroundColor: '#f5f5f5',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 4,
            boxShadow: 'none'
          }}>
          {selectedHelpOption?.length ? (
            <Box
              sx={{
                width: '100%',
                height: '100vh',
                justifyContent: 'center',
                display: 'flex'
              }}>
              <iframe
                src={selectedHelpOption}
                title={'Help Option Content'}
                style={{
                  width: '99%',
                  height: '92vh',
                  marginTop: '68px',
                  borderRadius: '8px',
                  borderColor: '#f4f6f8',
                  border: '0px'
                }}
              />
            </Box>
          ) : (
            <>
              {children}
              {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED &&companyLogo}
            </>
          )}
        </Box>
      </Stack>
    </Box>
  );
}

